import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './SuccessBind.css';

function SuccessBind() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    // 解析 URL 参数
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const phone = params.get('state'); // state 参数包含手机号
    
    console.log('微信授权回调参数:', { code, phone });
    
    // 调用绑定接口
    const bindPhoneAndWechat = async () => {
      try {
        setLoading(true);
        
        const response = await fetch('/users/bindPhoneAndWechatService', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            phone,
            code,
          }),
        });

        const data = await response.json();
        console.log('接口响应:', data);
        
        if (data.code === 10000) {
          console.log('绑定成功:', data);
          setSuccess(true);
        } else {
          console.error('绑定失败:', data);
          setSuccess(false);
          setErrorMessage('关联失败，请前往小程序联系客服');
        }
      } catch (error) {
        console.error('接口调用异常:', error);
        setSuccess(false);
        setErrorMessage('关联失败，请前往小程序联系客服');
      } finally {
        setLoading(false);
      }
    };

    if (code && phone) {
      bindPhoneAndWechat();
    } else {
      setLoading(false);
      setSuccess(false);
      setErrorMessage('参数不完整，请重新操作');
    }
  }, [location]);

  return (
    <div className="success-bind-container">
      <div className="success-bind-content">
        {loading ? (
          // 加载状态
          <>
            <div className="loading-wrapper">
              <div className="loading-spinner"></div>
            </div>
            <h1 className="success-title">正在关联...</h1>
          </>
        ) : success ? (
          // 成功状态
          <>
            <div className="success-icon-wrapper">
              <div className="success-icon">
                <svg className="checkmark" viewBox="0 0 52 52">
                  <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
                  <path className="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                </svg>
              </div>
            </div>
            <h1 className="success-title">关联成功</h1>
            <p className="success-tip">您的手机号已成功关联慧灵服务</p>
          </>
        ) : (
          // 失败状态
          <>
            <div className="error-icon-wrapper">
              <div className="error-icon">
                <svg className="error-mark" viewBox="0 0 52 52">
                  <circle className="error-circle" cx="26" cy="26" r="25" fill="none"/>
                  <path className="error-cross" fill="none" d="M16 16 36 36 M36 16 16 36"/>
                </svg>
              </div>
            </div>
            <h1 className="error-title">关联失败</h1>
            <p className="error-tip">{errorMessage}</p>
          </>
        )}
      </div>
    </div>
  );
}

export default SuccessBind;

